export default class Header {
  constructor(element) {
    this.element = element;
    this.html = document.documentElement;
    this.options = {
      scrollThreshold: 0.1,
      alwaysShow: false,
    };
    this.scrollPosition = 0;
    this.lastScrollPosition = 0;

    this.init();
    this.initNavMobile();
  }

  init() {
    this.setOptions();

    if (!this.options.alwaysShow)
      window.addEventListener('scroll', this.onScroll.bind(this));
  }

  setOptions() {
    // Vérifier les différents attributs data sur la composante
    if ('alwaysShow' in this.element.dataset) this.options.alwaysShow = true;
    if (
      'threshold' in this.element.dataset &&
      parseFloat(this.element.dataset.threshold)
    )
      this.options.scrollThreshold = parseFloat(this.element.dataset.threshold);
  }

  onScroll(event) {
    this.lastScrollPosition = this.scrollPosition;
    this.scrollPosition = document.scrollingElement.scrollTop;

    this.setDirections();
    this.setHeaderState();
  }

  setDirections() {
    if (this.scrollPosition > this.lastScrollPosition) {
      // Scroll vers le bas
      this.html.classList.remove('is-scrolling-up');
      this.html.classList.add('is-scrolling-down');
    } else {
      // Scroll vers le haut
      this.html.classList.remove('is-scrolling-down');
      this.html.classList.add('is-scrolling-up');
    }
  }

  setHeaderState() {
    if (
      this.scrollPosition > this.lastScrollPosition &&
      this.scrollPosition >
        document.scrollingElement.scrollHeight * this.options.scrollThreshold
    ) {
      // Scroll vers le bas
      this.html.classList.add('header-is-hidden');
    } else {
      // Scroll vers le haut
      this.html.classList.remove('header-is-hidden');
    }
  }

  initNavMobile() {
    // Configure l'écouteur de clic sur le bouton
    const toggle = this.element.querySelector('.js-toggle');
    toggle.addEventListener('click', this.onToggleNav.bind(this));

    // Configure les délais d'animation sur les items de la nav
    const navItems = this.element.querySelectorAll('.js-item');
    for (let i = 0; i < navItems.length; i++) {
      const navItem = navItems[i];
      navItem.style['animationDelay'] = `${i * 0.1}s`;
      console.log(i);
    }
  }

  onToggleNav() {
    document.documentElement.classList.toggle('nav-is-active');
  }
}
